import '../stylesheets/application_tailwind.css'